import { useContext } from 'react';
import { AlertDrawerContext } from '../features/dashboard/alert-drawer/AlertDrawerContext';
import { SupportDrawerContext } from './SupportDrawerContext';

/* Passing the preconfigured hook to components*/
export const useAlertDrawerContext = () => useContext(AlertDrawerContext);

export const useSupportDrawerContext = () => useContext(SupportDrawerContext);
